// The signed-in user's MCP clients (Claude and the like): the sign-in request one asks them to approve, and the
// connections they have approved.

import type { components } from '@/generated/contracts/api-v1';
import { toResult, v1 } from '@/infrastructure/api/v1/client';
import { list, read } from '@/modules/undoRedo/v1Rows';

export type McpAuthorizationRequest = components['schemas']['McpAuthorizationDto'];
export type McpAuthorizationDecision = components['schemas']['McpAuthorizationDecision'];
export type McpConnection = components['schemas']['McpConnectionDto'];

/** What a sealed sign-in request from an MCP client asks for (describeMcpAuthorization). */
export const describeMcpAuthorization = (request: string): Promise<McpAuthorizationRequest> =>
  read(v1.GET('/api/v1/mcp-authorizations', { params: { query: { request } } }));

/** Approves or denies a sealed sign-in request; resolves where the browser goes next (approveMcpAuthorization). */
export const approveMcpAuthorization = async (request: string, decision: McpAuthorizationDecision): Promise<string> =>
  (await read(v1.POST('/api/v1/mcp-authorizations', { body: { request, decision } }))).redirectUrl;

/** The MCP clients the signed-in user has connected, every page (listMyMcpConnections). */
export const listMyMcpConnections = (): Promise<McpConnection[]> =>
  list(page => v1.GET('/api/v1/users/me/mcp-connections', { params: { query: page } }));

/** Disconnects one of the signed-in user's MCP clients; one already gone (404) counts as done (revokeMyMcpConnection). */
export async function revokeMyMcpConnection(uniqueId: string): Promise<void> {
  const { error } = await toResult(v1.DELETE('/api/v1/users/me/mcp-connections/{uniqueId}', { params: { path: { uniqueId } } }));
  if (error && error.status !== 404) throw error;
}
